"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.popEnquireFormFromLocalStorage = exports.loadEnquireFormFromLocalStorage = exports.saveEnquireFormToLocalStorage = exports.saveSearchFromLocalStorage = exports.popSaveSearchFromLocalStorage = exports.saveSearchSetToLocalStorage = void 0;
var effects_1 = require("redux-saga/effects");
var WindowApi_1 = require("@/api/browser/WindowApi");
var StorageApi_1 = require("@/api/browser/StorageApi");
var RootSearchCallSaga_1 = require("@/pages/search/sagas/RootSearchCallSaga");
var RootSaveSearchCallSaga_1 = require("@/pages/savesearch/sagas/RootSaveSearchCallSaga");
var SaveSearchDialogSaga_1 = require("@/pages/search/sagas/SaveSearchDialogSaga");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var SaveSearchApiSaga_1 = require("@/pages/search/sagas/api/SaveSearchApiSaga");
exports.saveSearchSetToLocalStorage = function (email) {
    var searchHeading, saveSearchSet;
    if (email === void 0) { email = ''; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(RootSearchCallSaga_1.getSearchHeading)];
            case 1:
                searchHeading = _a.sent();
                return [4 /*yield*/, effects_1.call(RootSaveSearchCallSaga_1.getSaveSearchSet, searchHeading)];
            case 2:
                saveSearchSet = _a.sent();
                return [4 /*yield*/, effects_1.call(pushSaveSearchToLocalStorage, saveSearchSet)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var pushSaveSearchToLocalStorage = function (saveSearchSet) {
    var currentTime;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(WindowApi_1.getCurrentTime)];
            case 1:
                currentTime = _a.sent();
                return [4 /*yield*/, effects_1.call(StorageApi_1.setLocalStorage, 'saveSerchSet', JSON.stringify({
                        data: saveSearchSet,
                        create: currentTime,
                    }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
exports.popSaveSearchFromLocalStorage = function () {
    var saveSearchSetStr, saveSearchData, hasExpired;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(StorageApi_1.popLocalStorage, 'saveSerchSet')];
            case 1:
                saveSearchSetStr = _a.sent();
                if (!saveSearchSetStr)
                    return [2 /*return*/];
                saveSearchData = JSON.parse(saveSearchSetStr);
                if (!saveSearchData.create)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(isSaveSearchFromLocalStorageExpired, saveSearchData.create)];
            case 2:
                hasExpired = _a.sent();
                if (hasExpired)
                    return [2 /*return*/];
                return [2 /*return*/, saveSearchData.data];
        }
    });
};
var isSaveSearchFromLocalStorageExpired = function (create) {
    var now, week;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(WindowApi_1.getCurrentTime)];
            case 1:
                now = _a.sent();
                week = 7 * 24 * 60 * 60 * 1000;
                return [2 /*return*/, (now - create) > week];
        }
    });
};
var getSaveSearchesCountFromRemote = function () {
    var response, saveSearches;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.getSaveSearchCriteriaApi)];
            case 1:
                response = _a.sent();
                if (response && response.data.result && response.data.result.status === 2) {
                    saveSearches = response.data.searchSets;
                    return [2 /*return*/, saveSearches ? saveSearches.length : 0];
                }
                return [2 /*return*/, 0];
        }
    });
};
/**
 * Just sync only if this user has no save searches
 */
exports.saveSearchFromLocalStorage = function () {
    var saveSearchCount, langCode, saveSearchSet, silent;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(getSaveSearchesCountFromRemote)];
            case 1:
                saveSearchCount = _a.sent();
                if (!(saveSearchCount > 0)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.call(exports.popSaveSearchFromLocalStorage)];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 4:
                langCode = _a.sent();
                return [4 /*yield*/, effects_1.call(exports.popSaveSearchFromLocalStorage)];
            case 5:
                saveSearchSet = _a.sent();
                if (!saveSearchSet) return [3 /*break*/, 7];
                silent = true;
                return [4 /*yield*/, effects_1.call(SaveSearchDialogSaga_1.saveSearchSetToRemote, saveSearchSet, langCode, silent)];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/];
        }
    });
};
exports.saveEnquireFormToLocalStorage = function (enquireForm) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!enquireForm)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(StorageApi_1.setLocalStorage, 'enquiryForm', JSON.stringify(enquireForm))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
exports.loadEnquireFormFromLocalStorage = function () {
    var enquiryFormJsonStr;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(StorageApi_1.readLocalStorage, 'enquiryForm')];
            case 1:
                enquiryFormJsonStr = _a.sent();
                try {
                    return [2 /*return*/, JSON.parse(enquiryFormJsonStr)];
                }
                catch (e) { }
                return [2 /*return*/, null];
        }
    });
};
exports.popEnquireFormFromLocalStorage = function () {
    var enquiryFormJsonStr;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(StorageApi_1.popLocalStorage, 'enquiryForm')];
            case 1:
                enquiryFormJsonStr = _a.sent();
                try {
                    return [2 /*return*/, JSON.parse(enquiryFormJsonStr)];
                }
                catch (e) { }
                return [2 /*return*/, null];
        }
    });
};
